import { SendMediaOptions } from '@twilio/conversations';

export default (file: File): SendMediaOptions => ({
    contentType: file.type,
    filename: file.name,
    media: file,
});
